// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface INbtJsonItem {
  Count: number;
  Slot: number;
  id: string;
}
